import { ExtraProduct } from "ts/api/product";

type CalculateExtrasPriceParams = {
  extras: ExtraProduct[];
  selectedExtraIds?: string[];
  includeFees?: boolean;
};

const calculateExtrasPrice = ({
  extras,
  selectedExtraIds,
  includeFees,
}: CalculateExtrasPriceParams): number => {
  const ids = selectedExtraIds || extras?.map(({ id }) => id);
  const sumOfExtraPrices: number = extras?.reduce(
    (acc: number, extraProduct: ExtraProduct) => {
      const isChecked = ids?.includes(extraProduct.id);
      if (isChecked) {
        const productPriceForItem = includeFees
          ? extraProduct.priceWithFees
          : extraProduct.price;

        const quantity = extraProduct?.quantity || 1;
        const fullExtraPrice = productPriceForItem * quantity;
        return acc + fullExtraPrice;
      }

      return acc;
    },
    0
  );
  return sumOfExtraPrices;
};

export default calculateExtrasPrice;
